import * as React from "react";
import type { SVGProps } from "react";
const LinkedinBlack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={25}
    height={24}
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path fill="url(#pattern0_52_23)" d="M0 0h24.5v24H0z" />
    <defs>
      <pattern
        id="pattern0_52_23"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#image0_52_23" transform="scale(.0204 .02083)" />
      </pattern>
    </defs>
  </svg>
);
export default LinkedinBlack;
